import * as types from "../../constants";
import { addBreadcrumb, flush } from "../../utils/diagnostics/breadcrumbs";

export default function reducer(state = {}, actions) {
  switch (actions.type) {
    case types.AUTH_SIGN_IN_SUCCESS:
      return {
        ...state,
        user: {
          id: actions.id,
          email: actions.email,
          name: actions.name,
        },
      };

    case types.AUTH_SIGN_OUT:
        // BUG C defensive fix: don't nuke the whole localStorage on sign-out.
        //
        // The original `localStorage.clear()` wiped EVERY key, including
        // `sherwoodDiagSessionId` (so diagnostic continuity is lost across
        // sign-outs) and — critically — any third-party state that has no
        // business being wiped by our auth flow.
        //
        // ATTADIR on chom-dakar hit this today: a spurious AUTH_SIGN_OUT
        // fired ~1s after a successful login on `/` and wiped rawKeyResearcher,
        // breaking patient-data decryption (the Storage Proxy diagnostic
        // captured the stack: rJi → 379:10312 → h:379:8307 — TBD in source).
        //
        // Targeted removeItem means that even if a stray sign-out still fires,
        // only known auth keys are affected — nothing else. We still need to
        // root-cause WHO is dispatching AUTH_SIGN_OUT on that route; this fix
        // just reduces the blast radius while we investigate.
        // SHER-209: the signOut action creator breadcrumbs itself, so a reducer
        // run with no matching `auth.signOut.dispatched` right before it is the
        // proof that something dispatches AUTH_SIGN_OUT directly — which is the
        // open question this ticket's instrumentation exists to answer, and the
        // one a minified stack could not. Recorded here rather than inferred
        // later, because only the reducer sees the raw action.
        //
        // A breadcrumb is the same class of side effect this reducer already
        // performs (it writes to localStorage below); it is fully swallowed so
        // it can never stop the keys being cleared.
        try {
            const hadRawKey = Boolean(localStorage.getItem('rawKeyResearcher'));
            const hadJwt = Boolean(localStorage.getItem('jwt'));
            addBreadcrumb('state', 'auth.reducer.signOut', {
                hadRawKey,
                hadJwt,
                route: typeof window !== 'undefined' ? window.location?.pathname : undefined,
            });
            // Wiping a session that still held its encryption key is the reported
            // failure. Ship it now: the ring buffer would have rolled over long
            // before the user says "patient creation fails".
            if (hadRawKey) {
                flush('auth-reducer-signout');
            }
        } catch (_) { /* never let diagnostics block the key wipe */ }
        try {
            // All keys that the sign-in flow writes. Review-agent catch:
            // `keyResearcher` is still written by src/actions/index.js:22
            // (legacy path) and `type` by src/components/dashboard/login.jsx:65
            // — both were previously cleared by the blanket .clear() call, so
            // keep parity.
            localStorage.removeItem('jwt');
            localStorage.removeItem('password');
            localStorage.removeItem('rawKeyResearcher');
            localStorage.removeItem('keyResearcher');
            localStorage.removeItem('type');
        } catch (_) { /* ignore: localStorage may be unavailable in SSR/tests */ }
        return {
            ...state,
            user: undefined,
        };

    default:
      return state;
  }
}
